import apiV2Service from 'common/src/modules/api/api-v2.service';
import {GetContentFeedItemsResponse} from 'common/src/modules/contentFeedItems/contentFeedItems.types';

const BASE_PATH = 'ContentItems';

async function getFeedItems(feedId: number) {
  return apiV2Service
    .executeGetRequest<GetContentFeedItemsResponse>(`${BASE_PATH}/Feed/${feedId}`)
    .then(({data: reponse}) => reponse);
}

async function getFeedItemsByIds(feedId: number, itemIds: string[]) {
  const {data} = await apiV2Service.executePostRequest<GetContentFeedItemsResponse>(
    `${BASE_PATH}/Feed/${feedId}/GetByIds`,
    {},
    {itemIds},
  );

  return data;
}

export const contentFeedItemsApi = {
  getFeedItems,
  getFeedItemsByIds,
};
